module.exports = __webpack_public_path__ + "media/images/flags/gb-wls-d4bfee4ab960dc7da7e6c44dcef18dd1.svg";